import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { getSeoFooterFiltered } from '../../../../redux/actions/seo-footer'
import SeoFooter from '../../../../components/seo-footer'

interface FooterProps {
  filtersStore: {}
}

const Footer = ({ filtersStore }: FooterProps) => {
  const dispatch = useDispatch()

  useEffect(() => {
    filtersStore && dispatch(getSeoFooterFiltered(filtersStore))
  }, [filtersStore])

  return <SeoFooter />
}

const states = ({ filtersStore }) => ({
  filtersStore,
})

export default connect(states)(Footer)
